import React from "react";
import ReactJson from "react-json-view";
import styled from "styled-components";

import { ISqlRow } from "@formant/core/model/ISqlRow";

import { Scrollable } from "../common/Scrollable";

export interface IJsonViewerProps {
    rows: ISqlRow[];
}

export function JsonViewer(props: IJsonViewerProps) {
    const { rows } = props;

    const toJson = (value: string): string | object => {
        if (value.includes("{")) {
            try {
                return JSON.parse(JSON.parse(value));
            } catch (error) {
                return value;
            }
        }
        return value;
    };

    const rowData: {
        [key: string]: string | number | boolean | object;
    }[] = rows
        .slice(0, 50)
        .map(row =>
            Object.fromEntries(
                Object.entries(row).map(([key, value]) => [
                    key,
                    value === null ? "null" : toJson(String(value)),
                ]),
            ),
        );

    return (
        <Scrollable>
            <Container>
                <ReactJson src={rowData} theme="monokai" collapsed={true} />
            </Container>
        </Scrollable>
    );
}

const Container = styled.div`
    padding: 1rem;
    span {
        font-family: Moderat;
    }
    background-color: var(--formant-flagship) !important;
    .react-json-view {
        height: 100%;
        background-color: var(--formant-flagship) !important;
    }
`;
